import {
  TEAMS_ENDPOINT,
  TEAMS_CREATE_ENDPOINT,
  TEAMS_UPDATE_ENDPOINT,
  TEAMS_SHOW_ENDPOINT,
  TEAMS_DELETE_ENDPOINT,
} from 'constants/EndPoints'
import { get, post } from 'services/network'

export const getTeams = async (page, perPage, search) => {
  try {
    const response = await get(
      `${TEAMS_ENDPOINT}?page_size=${perPage}&page=${page}&search=${search}`,
      true
    )
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const createTeam = async (values) => {
  try {
    const response = await post(TEAMS_CREATE_ENDPOINT, values, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
export const updateTeam = async (values, id) => {
  try {
    const response = await post(`${TEAMS_UPDATE_ENDPOINT}/${id}`, values, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
export const showTeam = async (id) => {
  try {
    const response = await get(`${TEAMS_SHOW_ENDPOINT}/${id}`, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const minioSingleFileUpload = async (file) => {
  try {
    const response = await post(
      '',
      file,
      false,
      'https://micro-helper.ascend.com.sa/minio/upload'
    )
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
export const deleteTeam = async (id) => {
  try {
    const response = await post(`${TEAMS_DELETE_ENDPOINT}/${id}`, null, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
